import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import DeleteSitesModal from "../../sites/DeleteSitesModal";

/** Settings → Danger zone: delete this one site with the full provider teardown. */
export default function DangerZonePanel({ site }) {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const siteIds = useMemo(() => [site.id], [site.id]);
  return (
    <div className="border border-rose-900/60 bg-rose-950/20 rounded-sm p-4" data-testid="sitedetail-danger-zone">
      <div className="text-sm text-zinc-200 font-semibold">Delete this site</div>
      <p className="text-xs text-zinc-400 mt-1 leading-relaxed">
        Removes the site, its articles and subscribers, and tears down everything registered for <span className="mono text-zinc-200">{site.domain || site.slug}</span>: SparkPost / Infobip / Workspace domains, the Cloudflare zone, Worker bindings, Email Routing, analytics, Turnstile entry and R2 assets. Cloudflare Registrar auto-renew is switched off.
      </p>
      <button type="button" onClick={() => setOpen(true)} data-testid="sitedetail-delete-site-btn" className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-rose-200 border border-rose-500/50 bg-rose-600/15 hover:bg-rose-600/30 px-3 py-2 rounded-sm">
        <Trash2 size={12} /> Delete site & tear down…
      </button>
      {open && <DeleteSitesModal siteIds={siteIds} onClose={() => setOpen(false)} onDone={async () => { setTimeout(() => nav("/admin/sites"), 1200); }} />}
    </div>
  );
}
